import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '../PendingsCard';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import UnassignedInquiriesContainer from './UnassignedInquiriesContainer';
import { getUnassignedInquiries } from '@/store/slices/components/dashboard/service';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import UnassignedInquiriesEmptyState from './UnassignedInquiriesEmptyState';
import { useTrackPendingTab } from '../../customHooks/useTrackDashboard';

function UnassignedInquiries() {
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const dispatch = useDispatch();
  const track = useTrackPendingTab();
  const { count, loading, hasFetched, empty } = useSelector(
    (state) => state.DashboardSlice.unassignedInquiries
  );
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const urlRedirect = `${tokkoHost}/marketing/webcontact`;

  const inquiriesText = `${count} ${Trans(
    translations,
    count === 1 ? 'UnassignedInquiry' : 'UnassignedInquiries'
  )}`;

  useFetchOnViewport(
    (query) => {
      dispatch(getUnassignedInquiries(query));
    },
    [],
    { hasFetched }
  );

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={empty ? null : urlRedirect}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.unassignedInquiries(element)}
      >
        {inquiriesText}
      </PendingCard.Header>
      {empty ? (
        <UnassignedInquiriesEmptyState />
      ) : (
        <UnassignedInquiriesContainer
          trackCallback={(element) => track.unassignedInquiries(element)}
        />
      )}
    </PendingCard>
  );
}

export default UnassignedInquiries;
